// i18n area 'storage' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.tr-TR.meta.json.
import type { enUS } from './storage'

export const trTR: typeof enUS = {
  storage: {
    pools: {
      title: 'Depolama',
      createTitle: 'Depolama oluştur',
      path: 'Yol',
      pathHint: 'İzin verilen bir kök altında mutlak yol (varsayılan /var/lib/tvirt/pools/)',
      shared: 'Paylaşımlı depolama',
      sharedChip: 'paylaşımlı',
      sharedVerifiedChip: 'paylaşımlı · doğrulandı',
      sharedVerifiedTooltip: 'Paylaşım doğrulandı: çapraz düğüm sondaları, her üyenin diğerlerinin yazdığı verileri gördüğünü doğruluyor.',
      sharedDisputedChip: 'paylaşımlı · DOĞRULANMADI',
      sharedDisputedTooltip: 'Paylaşım DOĞRULANMADI',
      sharedDisputedPair: '{observer}, {writer} tarafından yazılan verileri görmüyor',
      sharedHint: 'Her üyede aynı yola yerel olarak bağlanmış bir ağ paylaşımı — canlı geçişin ön koşulu (bildirime dayalı).',
      sharedDanger: 'TEHLİKE — TVirt bu bayrağa İNANIR: açtığınızda her üye bu yolda AYNI baytları gördüğünü varsayar. Gerçekten paylaşımlı bir paylaşım (NFS/CIFS/küme dosya sistemi) olmayan bir klasörde sonuç, ilk geçişte veya başka bir düğümdeki ilk HA yeniden başlatmasında veri bozulması ve veri kaybıdır. Yalnızca yol her düğümde aynı şekilde bağlanmış bir paylaşımsa açın.',
      type: 'Tür',
      capacity: 'Kapasite',
      provisioned: 'Tahsis edilen',
      provisionedOvercommit: "Kapasitenin ötesinde potansiyel taahhüt: thin birimler {n} GiB'a kadar büyüyebilir.",
      phase: { ready: 'Hazır', degraded: 'Bozulmuş', error: 'Hata' },

      // Round #156: dialog dettagli — tab, righe per-driver, superficie osservata.
      tabConfig: 'Yapılandırma',
      tabCapacity: 'Kapasite ve durum',
      cardIdentity: 'Kimlik',
      cardPlacement: 'Yerleşim',
      cardConnection: 'Bağlantı',
      usedReal: 'Gerçek kullanım',
      capacityUnknown: 'Düğüm bu havuzun kapasitesini henüz bildirmedi — burada rakam uydurulmaz',
      overcommitHint: 'Kapasitenin ötesinde tahsis: thin havuzlarda meşrudur, gerçek kullanımı gözden kaçırmayın',
      supportedContent: 'Desteklenen içerikler',
      content: {
        disks: 'Diskler',
        catalogFiles: 'Katalog dosyaları',
        backups: 'Yedekler',
        appVolumes: 'App birimleri'
      },
      defaultDiskFormat: 'Varsayılan disk biçimi',
      reserveGiB: 'Rezerv boş alan (GiB)',
      available: 'Kullanılabilir',
      diskCount: 'Diskler',
      filesystem: 'Dosya sistemi',
      observedAt: 'Gözlemlenme zamanı',
      lostAtRow: 'Kayıp bildirilme zamanı',
      sharedProbeRow: 'Paylaşım doğrulaması',
      sharedProbeNodes: 'Sondalanan düğümler',
      reachableFrom: 'Bildirilen erişilebilirlik',
      reachableFromHint: "Bu depolamanın erişilebilir olması gereken düğümler. Diskleri, ISO'ları veya meta verileri burada duran bir VM, bu listenin dışındaki bir düğümde başlamaz ve oraya geçirilmez. Tüm üyeler önceden seçilidir: istediğiniz gibi daraltın. Kümeye sonradan katılan bir düğüm, siz buraya ekleyene kadar dışarıda kalır.",
      reachableFromNone: 'bildirilmedi',
      reachableFromTags: 'Etikete göre erişilebilirlik',
      reachableFromTagsHint: 'tag=değer seçici (virgülle ayrılmış girdiler, AND ile birleşir): bu etiketleri taşıyan her üye erişilebilir olarak bildirilir — dinamik olarak: bir düğümü etiketlemek onu içeri alır.',
      reachableFromTagsInvalid: 'Geçersiz biçim — virgülle ayrılmış tag=değer kullanın',
      reachableResolved: 'Çözümlenen düğümler: {nodes}',
      reachableDeclaredNotSeen: 'şu düğümlerde bildirildi ama paylaşım sondasınca görülmedi: {nodes}',
      reachableSeenNotDeclared: 'şu düğümlerde görüldü ama bildirilmedi (çevre dışı): {nodes}',
      cephCluster: 'Yönetilen Ceph kümesi',
      appGuardTitle: "App'ler tarafından kullanılan depolama",
      appEphemeralGuard: "bu depolama, App'lerin küme geneli geçici havuzudur — önce App sayfasından değiştirin, sonra silin.",
      appInUseGuard: 'burada app root/birimleri duruyor: {apps} — önce bunları taşıyın veya silin.',
      releaseRequiredTitle: "'{name}' silinip görüntüleri serbest bırakılsın mı?",
      releaseRequiredBatchTitle: 'Seçilen storage-lar silinip görüntüleri serbest bırakılsın mı?',
      releaseRequiredBody: 'Görüntüleri serbest bırakmak HİÇBİR baytı silmez: kayıttan düşürme namespace-i diskte bırakır, görüntüler yalnızca materyalize olmaktan çıkar ve scope referanslarının her biri claim olarak yaşamayı sürdürür — pool yeniden kaydedildiğinde tekrar sahiplenilirler.',
      releaseConfirm: 'Sil ve görüntüleri serbest bırak'
    },
    lost: {
      chip: 'Kayıp',
      action: 'Kayıp bildir',
      confirmTitle: 'Depolamayı kayıp bildir',
      confirmBody: 'Bildirdiğiniz risk size ait olmak üzere operatör beyanı: bu depolamayı veya nesnelerini hedefleyen, kuyruktaki ya da çalışan her görev BAŞARISIZ olacak, silmeler yalnızca kayıt üzerinde kalacak (dosya sisteminde işlem yok) ve yeni fiziksel iş reddedilecek. Baytlara asla dokunulmaz — arkadaki birim hayata dönerse yeniden kaydedin ve her şeyi yeniden sahiplenmek için bir tarama çalıştırın.',
      confirmSubmit: 'Kayıp bildir',
      error: 'Beyan reddedildi'
    },
    findings: {
      action: 'Bulunan nesneler',
      title: 'Bulunan nesneler',
      empty: "Depolama namespace'inde bulunan nesne yok",
      loadError: 'Bulunan nesneler yüklenemedi',
      actionError: 'Karar reddedildi',
      colKind: 'Tür',
      colObject: 'Nesne',
      colConflict: 'Çakışma',
      namespaceNotice:
        'Bu dizin başka bir depolama tarafından zaten başlatılmıştı: kimlik mührü bu depolamanınkiyle yeniden yazıldı. İçeriğe DOKUNULMADI — aşağıda bulunan nesneleri incele, ihtiyacın olanları içe aktar, sonra bu bildirimi kapat.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalog dosyası',
        vmMetadata: 'VM meta verisi',
        namespace: 'Namespace',
        foreign: 'Yabancı',
        volumeGroup: 'Birim grubu'
      },
      vgAdopt: {
        action: 'Birim grubunu benimse',
        title: 'Birim grubunu benimse',
        intro:
          'Bu aygıt zaten TVirt adı taşıyan bir birim grubu barındırıyor, ancak mührü burada kayıtlı hiçbir storage\'ı adlandırmıyor. BU kümenin önceki bir storage\'ının LUN üzerinde bıraktığı şey olabilir — ya da el değiştirmiş bir LUN üzerinde BAŞKA bir TVirt kümesinin bıraktığı şey: buradan iki durum aynı görünür, bu yüzden kimse sizin yerinize karar vermez.',
        irreversible: 'Devam etmeden önce aygıta, mühre ve ada bakın: benimseme geri alınamaz.',
        device: 'Aygıt',
        seal: 'Mühür',
        sealNone: 'yok (tvirt.storageId etiketi yok)',
        renameTo: 'Şu ada yeniden adlandırılacak',
        renameNone: 'Yeniden adlandırma yok: ad zaten bu storage\'ın türettiği ad',
        volumesNote:
          'İçerdiği birimler bu hareketle benimsenMEZ: sonraki tarama onları teker teker, sıradan bulunan nesneler olarak sunar.'
      },
      conflictChip: 'ID zaten var',
      dismissedChip: 'Yoksayıldı',
      adopt: 'Sahiplen',
      adoptFileTitle: 'Bir kataloğa içe aktar',
      adoptFileHint: 'Dosyalar yalnızca katalogların içinde var olur: bulunan dosya için hedef kataloğu seçin.',
      purge: 'Diskten sil',
      dismiss: 'Yoksay',
      purgeConfirmTitle: 'Diskten sil',
      purgeConfirmBody: "'{id}' için bulunan baytlar depolamadan kaldırılacak. Bu işlem geri alınamaz.",
      taskStarted: 'Başlatıldı — arka planda görev olarak devam ediyor',
      scan: 'Depolamayı tara',
      scanStarted: 'Tarama başlatıldı…',
      scanDone: 'Tarama tamamlandı — bulunan nesneler güncel'
    },
    reinit: {
      action: 'İlklendirmeyi yeniden dene'
    },
    wizard: {
      addButton: 'Ekle',
      title: 'Depolama ekle',
      back: 'Geri',
      continue: 'Devam',
      selectHint: "TVirt'in protokolü nasıl kullandığını görmek için bir protokol seçin.",
      roadmap: 'Roadmap',
      server: 'Sunucu',
      export: 'Dışa aktarılan yol',
      share: 'Paylaşım',
      username: 'Kullanıcı adı',
      password: 'Parola',
      passwordHint: 'Yalnızca yazılır: bağlama için kullanılır, bir daha asla gösterilmez.',
      credential: 'Kimlik bilgisi',
      credentialManual: 'El ile gir',
      credentialHint: 'Kullanıcı adı ve parola türünde bir keystore girdisi — bunları buraya yazmanın alternatifi.',
      credentialEmpty: 'Keystore içinde henüz kullanıcı adı ve parola türünde kimlik bilgisi yok — Sistem → Kimlik bilgileri altında oluşturun ya da aşağıya account bilgilerini yazın.',
      options: 'Bağlama seçenekleri',
      optionsHint: 'Virgülle ayrılır, mount -o komutuna olduğu gibi geçirilir.',
      portal: 'Portal',
      portalHint: 'host[:port] — varsayılan port 3260.',
      target: 'Target IQN',
      targetHint: 'iSCSI target adı, iqn. ile başlar.',
      lun: 'LUN',
      wholeLunRow: 'Disklerde: bu depolama yalnızca hedefi adlandırır',
      wholeLunHint: 'Bu depolama yalnızca hedefi adlandırır: LUN\'ları tek tek disk olur (Disk oluştur → tam LUN devral), hedefe hiçbir şey yazılmaz.',
      lunHint: 'Target üzerindeki LUN numarası — emin değilseniz 0.',
      chapCredential: 'Kimlik bilgisi (CHAP)',
      chapCredentialHint: 'Oturum açmada kullanılan CHAP (iSCSI) türünde bir keystore girdisi — gizli değer asla depolamayla birlikte taşınmaz.',
      chapNone: 'Kimlik doğrulama yok',
      chapEmpty: 'Keystore içinde CHAP (iSCSI) türünde kimlik bilgisi yok — Sistem → Kimlik bilgileri altında oluşturun. Onsuz oturum açma kimlik doğrulamasız kalır.',
      address: 'Adres',
      addressHint: 'NVMe/TCP target için host veya IP (traddr).',
      port: 'Port',
      portHint: 'Target TCP portu — boş bırakılırsa 4420.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Target üzerindeki subsystem NQN değeri, nqn. ile başlar.',
      nsid: 'NSID',
      nsidHint: 'Subsystem içindeki Namespace ID — emin değilseniz 1.',
      dhchapCredential: 'Kimlik bilgisi (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Bağlantı sırasında kullanılan DH-HMAC-CHAP (NVMe) türünde bir keystore girdisi — gizli değer asla depolamayla birlikte taşınmaz.',
      dhchapNone: 'Kimlik doğrulama yok',
      dhchapEmpty: 'Keystore içinde DH-HMAC-CHAP (NVMe) türünde kimlik bilgisi yok — Sistem → Kimlik bilgileri altında oluşturun. Onsuz bağlantı kimlik doğrulamasız kalır.',
      monitors: 'Monitörler',
      monitorsHint: 'Ceph monitör uç noktaları, host[:port], virgülle veya satır satır ayrılır — varsayılan port 6789.',
      pool: 'Havuz',
      poolHint: 'Kullanılacak RBD havuzu — disk başına bir RBD görüntüsü.',
      fs: 'Dosya sistemi',
      fsHint: 'CephFS dosya sistemi adı (bağlama sırasında mds_namespace).',
      fsPath: 'Dosya sistemi içindeki yol',
      fsPathHint: 'Depolamanın bağladığı, dosya sistemi içindeki mutlak yol — emin değilseniz /.',
      cephxCredential: 'Kimlik bilgisi (cephx)',
      cephxCredentialHint: 'cephx türünde bir keystore girdisi: username = client adı (client.…), secret = base64 anahtar. Zorunlu.',
      cephxNone: 'Keystore içinde cephx kimlik bilgisi yok — Sistem → Kimlik bilgileri altında bir tane oluşturun (tür: cephx) ya da yönetilen bir Ceph kümesinin "Depolama olarak öner" ile basmasına izin verin.',
      sharedByNature: 'Ağ depolamaları doğası gereği paylaşımlıdır: her üye onları TVirt tarafından yönetilen aynı yola bağlar.',
      error: 'Depolama reddedildi',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Diğer',
        legacy: 'Legacy'
      },
      legacyHint: 'Tam olarak desteklenir — yalnızca yeni bir kurulum için bunları seçmezdik.',
      proto: {
        // La riga `usage` dice come TVirt usa il protocollo (contenuti ammessi).
        dir: {
          name: 'Yerel klasör',
          desc: 'Düğüm üzerinde bir dizin: basit ve hızlı. Yol gerçekten paylaşımlı bir paylaşım değilse tek bir düğüme YERELDİR — öyle değilken paylaşımlı işaretlemek veriye mal olur.',
          usage: 'TVirt burada VM disklerini, ISO/disk görüntülerini ve şablonları saklar.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Kümenin bağladığı bir NFS export — doğası gereği paylaşımlı.',
          usage: 'VM disklerini, ISO/disk görüntülerini ve şablonları barındırır.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Kümenin bağladığı bir Windows/Samba paylaşımı — doğası gereği paylaşımlı.',
          usage: 'VM disklerini, ISO/disk görüntülerini ve şablonları barındırır.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'SSH üzerinden uzak bir dosya sistemi — NAS export gerekmez.',
          usage: "Roadmap'te."
        },
        iscsi: {
          name: 'iSCSI',
          desc: "IP üzerinden blok LUN'lar, üstte paylaşımlı LVM ile.",
          usage: 'Yalnızca diskler — disk başına bir thin birim; ISO görüntüsü veya şablon barındırmaz.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Bir Ceph kümesi üzerinde dağıtık blok aygıtlar.',
          usage: 'Yalnızca diskler — disk başına bir RBD görüntüsü, QEMU tarafından yerel olarak açılır; ISO görüntüsü barındırmaz.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Ceph dağıtık dosya sistemi, kümede çekirdek tarafından bağlanır — shared by nature.',
          usage: 'VM disklerini, ISO/disk görüntülerini ve şablonları barındırır — Ceph dosya sistemi üzerinde dir ailesi (cephx kimlik bilgisi zorunlu).'
        },
        fc: { name: 'SCSI/FC', desc: "FibreChannel fabric üzerinden SCSI LUN'lar — klasik FC SAN." },
        fcoe: { name: 'SCSI/FCoE', desc: 'Aynı FibreChannel üzerinden SCSI, FC çerçeveleri Ethernet içine kapsüllenmiş halde.' },

        // La chiave è il nome del driver del contract (round #132).
        'iscsi-lun': {
          name: 'iSCSI (tam LUN\'lar)',
          desc: 'Tam LUN taşıyıcısı olarak iSCSI hedefi: her disk bir LUN\'DUR, konuğa ham olarak verilir — arada LVM yok.',
          usage: 'Yalnızca diskler — disk başına tam bir LUN, olduğu gibi devralınır; paylaşımlı yazılan disklerin SAN evi.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (tam namespace\'ler)',
          desc: 'Tam namespace taşıyıcısı olarak NVMe alt sistemi: her disk bir namespace\'TİR, konuğa ham olarak verilir.',
          usage: 'Yalnızca diskler — disk başına tam bir namespace, olduğu gibi devralınır; paylaşımlı yazma evet, SCSI persistent reservation hayır.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Uzak NVMe — yolda SCSI yok — düz TCP üzerinden, üstte paylaşımlı LVM ile.',
          usage: 'Yalnızca diskler — disk başına bir thin birim; ISO görüntüsü veya şablon barındırmaz.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'FibreChannel fabric üzerinden uzak NVMe.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: "FCoE'nin Ethernet içinde taşıdığı FibreChannel fabric üzerinden NVMe — FCoE ve NVMe/FC katmanları üst üste." },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'Veri yolu RDMA üzerine taşınmış iSCSI — herhangi bir fabric (InfiniBand, iWARP, RoCE). Yerini NVMe/RDMA aldı; depolama dizileri ve ESXi hâlâ sunuyor.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'RDMA üzerinden yerel SCSI, iSER öncesi dönem: InfiniBand (fabric keşfiyle) ve RoCE — eski HPC depolamalarında yaşamaya devam ediyor.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Herhangi bir RDMA fabric üzerinden uzak NVMe — InfiniBand, iWARP, RoCE v1 ve v2: tek yapılandırma, hangisine sahip olduğunu düğüm bildirir.' },
        s3: { name: 'S3', desc: 'S3 uyumlu nesne depolama — görüntüler ve yedekler.' }
      }
    },
    catalogs: {
      title: 'Kataloglar',
      createTitle: 'Katalog oluştur',
      editTitle: 'Kataloğu düzenle',
      docTitle: 'Katalog',
      notFound: 'Bu katalog (artık?) mevcut değil',
      scopeHint: "Bu scope'u okuyan herkes katalogdaki her dosyayı görür (ve kullanabilir)",
      files: 'Dosyalar',
      noFiles: 'Dosya yok',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Il catalogo di sistema (round #126): leggibile da tutti, scrivibile da nessuno.
      systemChip: 'sistem',
      systemTooltip: 'Sistem kataloğu: platformun gömülü nesnelerini barındırır ve değiştirilemez'
    },

    // File di catalogo (round K1): una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Tür',
      physicalSize: 'Fiziksel boyut',
      virtualSize: 'Sanal boyut',

      // Round K3 (#64) + K4 (#65): file vm-template → VM Template dell'inventario.
      importTemplateAction: 'VM Template olarak içe aktar',
      importTemplateLegacy: 'Bildirilen biçim yok — disk için seed olarak kullanılabilir, içe aktarılamaz',
      importTemplateTitle: 'VM Template olarak içe aktar',
      importTemplateSubmit: 'İçe aktar',
      importTemplateError: 'İçe aktarma başarısız',
      importTemplateHint: ".tvtpl paketi bir VM Template olur: manifest içindeki dondurulmuş donanım artı arşivdeki her entry için bir disk; her biri kendi checksum değeriyle doğrulanır. NIC'ler ve CD/DVD ortamları arşivin parçası değildir — bunları içe aktarmadan sonra ekleyin.",
      importTemplateQcow2Hint: 'Çıplak bir qcow2, bildirilen varsayılan donanımla TEK diskli bir şablona dönüşür: linux profili, UEFI, 2 vCPU, 2048 MiB, tek diskinden önyükleme. Dağıtım sırasında düzeltin.',
      importTemplateName: 'Şablon adı',
      importTemplateNameHint: 'Boş = {name} (doluysa -import-<n>)',
      importTemplateStorage: 'Diskler için depolama',
      importTemplateMetadataStorage: 'Meta veri depolaması',
      importTemplateMetadataHint: 'Blok depolama VM meta verilerini (firmware, varstore) barındırmaz — dir/nfs/cifs türünde birini seçin.',
      importTemplateStarted: 'İçe aktarma başlatıldı — görev tamamlandığında şablon, Şablonlar sekmesinde görünür.',

      // Etichette parlanti al singolare (#86); il generico resta fallback.
      kind: {
        iso: 'ISO görüntüsü',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM şablonu',
        'oci-image': 'OCI görüntüsü',
        'firmware-ovmf': 'OVMF firmware'
      },
      title: {
        iso: 'ISO görüntüleri',
        'ct-rootfs': 'CT şablonları',
        'vm-template': 'VM şablonları',
        'oci-image': 'OCI görüntüleri',
        'firmware-ovmf': 'OVMF firmware'
      },
      createTitle: {
        iso: 'ISO görüntüsü ekle',
        'ct-rootfs': 'CT şablonu kaydet',
        'vm-template': 'VM şablonu ekle',
        'oci-image': 'OCI görüntüsü ekle',
        'firmware-ovmf': 'OVMF firmware ekle'
      },
      formatHint: 'Seçilen dosyanın uzantısından türetildi — yanlış tahmin ettiyse düzeltin',
      tarballHint: 'Standart LXC biçiminde bir rootfs tarball (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 ya da düz bir .tar)',
      ociArchiveHint: 'Bir docker-archive / oci-archive tarball (.tar veya .tar.gz), örneğin docker save çıktısı',
      uploadResumeHint: 'Karşıya yükleme kesildi — dosya yükleme bekliyor: devam etmek için aynı dosyayla yeniden gönderin',
      moveTitle: 'Dosyayı taşı',
      moveHint: 'İki bağımsız boyut: Katalog bağlantıyı taşır (aynı id, hiçbir bayt taşınmaz, scope hedef kataloğunki olur); Depolama veriyi taşır — bağlantılı her kopya onu izler, dosya kullanımdayken reddedilir. Birlikte seçilirse önce katalog, sonra depolama.',
      moveCatalog: 'Hedef katalog',
      moveCatalogHint: 'Yalnızca bağlantı ev değiştirir: dosyayı bağlamış bir VM hedef kataloğu görebilmelidir',
      keepCurrent: 'Değiştirme',
      rehomed: 'Bağlantı seçilen kataloğa taşındı',
      copyAction: 'Kataloğa kopyala…',
      copyTitle: 'Kataloğa kopyala',
      copyLinkHint: 'Kopya, aynı verilere yeni bir bağlantıdır — depolamada hiçbir şey çoğaltılmaz.',
      copyCatalog: 'Hedef katalog',
      copyCatalogHint: 'Kopyalama, bir dosyanın kataloglar arasında dolaşma yoludur',
      sameCatalog: 'Kaynakla aynı',
      sharedObjectHint: 'Bu dosyanın verileri {count} bağlantılı kopya tarafından paylaşılıyor',
      deleteLastLink: 'Bu, söz konusu içeriğe giden SON bağlantı: veriler de depolamadan silinecek.',
      deleteLinkOnly: 'Yalnızca bu bağlantı kaldırılacak — veriler kalır ve diğer bağlantılı kopyalardan ({count}) erişilebilir olmaya devam eder.',
      noCatalog: 'Henüz katalog yok — bir tane oluşturun',
      inlineCatalogName: 'Katalog adı',

      // File integrati (round #126): storage null — solo lettura e clone.
      embeddedChip: 'gömülü',
      embeddedStorage: 'Platforma gömülü',
      embeddedNoMove: 'Platforma gömülü dosya: hiçbir depolamada durmaz — bunun yerine klonlayın',
      embeddedCopyHint: 'Klon, gömülü baytları gerçek bir depolamaya somutlaştırır: hedef depolamayı ve kataloğu seçin — kopya sıradan bir dosyadır',
      sourceEmbedded: 'Platforma gömülü',
      nodesRow: 'Düğüm başına mevcudiyet',
      nodesSummary: '{total} düğümden {present} tanesinde var',
      nodePresent: 'mevcut',
      nodeMissing: 'eksik',
      nodeUnknown: 'henüz bildirilmedi',
      nodesHint: 'Varlık her düğümün diskinde yaşar (trantor-tvirt-assets paketi): ona sahip olmayan bir düğüm ne bu firmware ile VM tanımlayabilir ne de Guest Tools sunabilir. Düğümler arasında farklı sürümler, aşamalı güncelleme sırasında normaldir.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'İndir',
      downloadNotReady: 'İçerik henüz hazır değil — indirme, ready durumundaki bir dosya gerektirir',
      downloadDenied: 'Rolünüz catalog.download iznini içermiyor — baytları indirmek, dosyayı kullanmaktan ayrı bir haktır',

      // Round #156: righe di lettura del dialog dettagli.
      objectRow: 'Depolama nesnesi',
      objectLinksRow: 'Bağlantılı kopyalar',
      declaredChecksum: 'Bildirilen SHA-256',
      usedByRow: 'Kullananlar',
      usedByVms: "VM'ler",
      usedByDisks: 'Diskler',
      transferRow: 'Aktarım',
      storageLockHint: 'Yalnızca Taşı eylemiyle değişir'
    },

    // Censimento per-storage (round K1): sola lettura.
    objects: {
      action: 'İçerikleri keşfet',
      title: 'Depolama içeriği',
      hint: 'Bu depolamada duranların salt okunur sayımı — her nesne kendi bölümünden yönetilir.',
      empty: 'Bu depolamada kayıtlı nesne yok',
      loadError: 'İçerik yüklenemedi',
      colDetail: 'Ayrıntı',
      manage: 'Kendi bölümünde yönet',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalog dosyası',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM meta verisi',
        appRoot: 'App root',
        appVolume: 'App birimi'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloglar',
      storage: 'Depolama',
      sizeGib: 'Boyut (GiB)',
      format: 'Biçim',
      size: 'Boyut',
      sourceType: 'Kaynak',
      sourceFile: 'Karşıya dosya yükleme',
      sourceUrl: "URL'den indirme",
      file: 'Dosya',
      url: 'URL',
      checksum: 'SHA-256 checksum',
      checksumHint: 'Zorunlu: indirme bu SHA-256 ile doğrulanır',
      verifyChecksum: 'Checksum doğrula',
      checksumOffHint: 'İndirme doğrulanmadan kabul edilecek — hesaplanan SHA-256 yine de kaydedilir',
      uploading: 'Karşıya yükleniyor…',
      move: {
        action: 'Taşı',
        diskTitle: 'Diski taşı',
        target: 'Hedef depolama',
        diskHint: 'Disk kimliğini korur: baytlar seçilen depolamaya taşınır. Diski kullanan VM kapalı olmalıdır; anlık görüntüler varken iSCSI taraf taşımayı reddeder.',
        noTargets: 'Uyumlu hedef depolama yok',
        submit: 'Taşı',
        error: 'Taşıma reddedildi'
      },
      clone: {
        action: 'Klonla',
        title: 'Diski klonla',
        name: 'Kopyanın adı',
        storage: 'Hedef depolama',
        sameStorage: 'Kaynakla aynı',
        linked: 'Linked clone',
        linkedHint: 'Kaynak diske zincirlenmiş anında qcow2 overlay (yalnızca qcow2 kaynaklar). Varsayılan, tam kopyadır.',
        linkedCrossHint: 'Linked clone kaynağın depolamasında kalmalıdır: etkinleştirmek için "Kaynakla aynı" seçin.',
        submit: 'Klonla',
        error: 'Klonlama reddedildi'
      },
      copy: {
        action: 'Kopyala',
        name: 'Kopyanın adı',
        storage: 'Hedef depolama',
        sameStorage: 'Kaynakla aynı',
        submit: 'Kopyala',
        error: 'Kopyalama reddedildi'
      },
      taskStarted: 'Başlatıldı — arka planda görev olarak devam ediyor',
      cephObjects: 'Ceph üzerindeki nesne ayrıntılarına git',
      phase: {
        ready: 'Hazır',
        creating: 'Oluşturuluyor',
        'awaiting-upload': 'Karşıya yükleme bekleniyor',
        downloading: 'İndiriliyor',
        verifying: 'Doğrulanıyor',
        deleting: 'Siliniyor',
        error: 'Hata',
        'in-use': 'Kullanımda'
      }
    }
  }
}
